const deriveFileName = (url: string): string => {
    try {
        const pathname = new URL(url, window.location.href).pathname;
        const segments = pathname.split('/').filter(Boolean);
        const last = segments[segments.length - 1];
        return last && last.length > 0 ? decodeURIComponent(last) : 'image.jpg';
    } catch {
        return 'image.jpg';
    }
};

export const fetchUrlAsFile = async (url: string): Promise<File> => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP ${response.status} for ${url}`);
    }
    const blob = await response.blob();
    const type = blob.type || response.headers.get('content-type') || 'image/jpeg';
    const name = deriveFileName(url);
    return new File([blob], name, { type });
};